export default {
  "bbt.gnav.menu": "",
  "bbt.gnav.eventProgram": "",
  "bbt.gnav.news": "",
  "bbt.gnav.report": "",
  "bbt.gnav.supporter": "",
  "bbt.gnav.about": "",
  "bbt.gnav.linkj": "",
  "bbt.gnav.cic": "",
  "bbt.gnav.mri": "",
} as const;
